import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Popover as BootstrapPopover, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface PopoverProps {
  title: string;
  idGroupAlarm: number;  // Group alarm API endpoint
  icon: string;
  colorLink: string;
  idAlarm: number;
  type: string;
}

interface GroupAlarmsProps {
  id_groupe_alarme: number;
  id_user: string;
  name_groupe_alarme: string;
  description: string;
  notify_email: boolean;
  notify_app: boolean;
  notify_type_app_list: number[];    // List of alert types via app
  notify_user_app_list: number[];    // List of selected user IDs
  notify_mail_list: number[];
  username_user: string;
}

const PopoverComponent: React.FC<PopoverProps> = ({ title, idGroupAlarm, icon, colorLink, idAlarm, type }) => {
  const [content, setContent] = useState<string>('Loading...');
  const [loading, setLoading] = useState<boolean>(false);
  const [groupAlarm, setGroupAlarm] = useState<GroupAlarmsProps | null>(null);

  const getSingleGroupAlarm = async (id_groupe_alarme: number): Promise<GroupAlarmsProps | null> => {
    try {
      setLoading(true);
      const response = await fetch(`${backendUrl}/api/alarm/group/find/${id_groupe_alarme}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
      });

      const data = await response.json();

      if (data) {
        return data;
      } else {
        console.warn("No data found for this group alarm.");
        return null;
      }
    } catch (error) {
      console.error("Failed to fetch group alarm:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const getVehiclesAlarm = async (idAlarm: number): Promise<any | null> => {
    try {
      setLoading(true);

      const response = await fetch(`${backendUrl}/api/alarm/vehicule/find/${idAlarm}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
      });

      const data = await response.json();

      if (data && Array.isArray(data.devices)) {
        return { success: data.success, devices: data.devices };
      } else {
        console.warn("No Vehicles found for this group alarm.");
        return null;
      }
    } catch (error) {
      console.error("Failed to fetch Vehicles for alarm:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const refreshSingleGroupAlarm = async (id_groupe_alarme: number) => {
    const alarm = await getSingleGroupAlarm(id_groupe_alarme);
    if (alarm) {
      setGroupAlarm(alarm);
      setContent(`
        Name: ${alarm.name_groupe_alarme}<br />
        Email Notification: ${alarm.notify_email ? 'Yes' : 'No'}<br />
        App Notification: ${alarm.notify_app ? 'Yes' : 'No'}<br />
      `);
    } else {
      setContent('Failed to load alarm details.');
    }
  };

  const refreshVehiclesAlarm = async (idAlarm: number) => {
    try {
      const alarmResponse = await getVehiclesAlarm(idAlarm);

      if (alarmResponse && alarmResponse.success) {
        const values = alarmResponse.devices.map((item: any) => item.value.trim());
        setContent(`Vehicles: <br />${values.join('<br />')}`);

      } else {
        setContent('Failed to load vehicle alarm attached to details.');
      }
    } catch (error) {
      console.error("Error fetching vehicles alarm:", error);
      setContent('An error occurred while fetching vehicle alarms.');
    }
  };

  const handleEntering = () => {
    if (type === "methods") {
      refreshSingleGroupAlarm(idGroupAlarm);
    } else {
      refreshVehiclesAlarm(idAlarm);
    }
  };

  const popover = (
    <BootstrapPopover id={`popover-${idAlarm}`}>
      <BootstrapPopover.Header as="h3">{title}</BootstrapPopover.Header>
      <BootstrapPopover.Body
        dangerouslySetInnerHTML={{
          __html: content  
        }}
      />
    </BootstrapPopover>
  );


  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      overlay={popover}
      onEntering={handleEntering}  // Use the new handleEntering function
    >
      <a className={colorLink} style={{ cursor: "pointer" }}>
        <i className={`fa fa-${icon}`}></i>
      </a>
    </OverlayTrigger>
  );
}

export default PopoverComponent;
